import 'mobiotics-logger';

const LEVEL=process.env.REACT_APP_ENV === 'development' ? Logger.levels.ON : Logger.levels.OFF;

Logger.setLevel(LEVEL);